import { generateClient } from 'aws-amplify/api'
import { CommonPublicClientOptions } from '@aws-amplify/api-graphql'
import { getAccessToken } from '../utils/cognito'

const getAppSyncClient = (options: CommonPublicClientOptions = {}) => {
  /**
   * The access token.
   */
  const accessToken = getAccessToken()

  if (accessToken) {
    // Set the authorization mode to 'userPool'.
    options.authMode = 'userPool'

    // Set the access token as the authorization token.
    options.authToken = accessToken

    options.endpoint = import.meta.env.VITE_APP_APP_SYNC_ENDPOINT ?? ''

    // Set the authorization header.
    options.headers = {
      Authorization: `${accessToken}`
    }
  }
  // Return the GraphQL client.
  const client = generateClient(options)

  return client
}

export default getAppSyncClient
